import apiClient from "../../axios/apiClient";


export const getCameraNvrList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CAMERANVRLIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/nvrs`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CAMERANVRLIST_FULFILLED",
          payload: response.data?.data,
          cameraNvrCount: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_CAMERANVRLIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const saveCameraNvrData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_CAMERANVR_PENDING" });

    const response = await apiClient.post(
      `/api/v1/nvrs`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CAMERANVR_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_CAMERANVR_REJECTED", payload: error.response });
  }
};


export const getCameraNvrListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CAMERANVRLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/nvrs/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_CAMERANVRLISTBYID_FULFILLED",
        payload: response.data?.data,
        cameraNvrCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_CAMERANVRLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateCameraNvrData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_CAMERANVR_PENDING" });

    const response = await apiClient.put(
      `/api/v1/nvrs/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CAMERANVR_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CAMERANVR_REJECTED", payload: error.response });
  }
};


// export const updateCameraStatusData = (token, id, status) => async (dispatch) => {
//   try {
//     dispatch({ type: "UPDATE_CAMERA_STATUS_PENDING" });
//     const data = {
//       "status": status
//     }
//     const response = await apiClient.put(
//       `/api/v1/cameras/${id}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     dispatch({ type: "UPDATE_CAMERA_STATUS_FULFILLED", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "UPDATE_CAMERA_STATUS_REJECTED", payload: error.response });
//   }
// };


export const deleteCameraNvrData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_CAMERANVR_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/nvrs/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_CAMERANVR_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_CAMERANVR_REJECTED", payload: error.response });
  }
};

// export const playCameraData = (token, id) => async (dispatch) => {
//   try {
//     dispatch({ type: "PLAY_CAMERA_PENDING" });

//     const response = await apiClient.get(
//       `/api/admin/v1/Play-Camera/${id}`, // Endpoint URL with City ID
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     dispatch({ type: "PLAY_CAMERA_FULFILLED", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "PLAY_CAMERA_REJECTED", payload: error.response });
//   }
// };

// export const stopCameraData = (token, id) => async (dispatch) => {
//   try {
//     dispatch({ type: "STOP_CAMERA_PENDING" });

//     const response = await apiClient.get(
//       `/api/admin/v1/Stop-Camera/${id}`, // Endpoint URL with City ID
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     dispatch({ type: "STOP_CAMERA_FULFILLED", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "STOP_CAMERA_REJECTED", payload: error.response });
//   }
// };
